import styled from 'styled-components'

import Theme from '@theme'

export const ChartContainer = styled.div`
  width: 100%;
  position: relative;
`

export const SVGContainer = styled.div`
  width: 100%;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;

  svg {
    display: block;
    height: auto;
  }
`

// Overlays the empty-state caption in the bottom margin (where the data state draws
// its category labels) so it adds no height — keeping empty and data charts identical.
// Flush at the bottom to line up with the chart.js siblings, whose subtitle plugin
// draws "Data not yet available" at the very bottom of their canvases (BRAND-9360).
export const EmptyCaption = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
`

export const ChartTitle = styled.h3`
  font-size: 1rem;
  font-weight: 500;
  color: ${Theme.grey900Color};
  margin: 0 0 1rem;
`

export const Tooltip = styled.div`
  position: absolute;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  background-color: ${Theme.grey900Color};
  color: ${Theme.whiteColor};
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.4;
  box-shadow: 0 2px 8px rgb(0 0 0 / 15%);
  z-index: 1000;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  max-width: 200px;
  word-wrap: break-word;
`
